import StudioModal from '@/components/modals/StudioModal.vue';
import { Component } from 'vue-property-decorator';
import { EModalName } from '@/helpers/modal';
import { Button } from 'streamlabs-beaker';
import ThemeLibraryMixins from './ThemeLibraryMixins';
import { ITheme } from '@/helpers/theme';

@Component({
  components: {
    StudioModal,
    SButton: Button,
  },
})
export default class ThemeLibraryModal extends ThemeLibraryMixins {
  get modalName(): string {
    return EModalName.themeLibrary;
  }

  get title(): string {
    return this.previewTheme ? this.previewTheme.name : 'Overlay Library';
  }

  hideModal() {
    this.resetThemeModal();
    this.$modal.hide(this.modalName);
  }

  onPreviewApply() {
    this.themeToInstall = this.previewTheme;
    this.onApply();
  }

  onThemeApplyClick(themeToInstall: ITheme) {
    this.setThemeToInstall(themeToInstall);
    this.onApply();
  }

  onApply() {
    this.hideModal();
    this.$modal.show(EModalName.themeApplyConfirmation);
  }
}
